"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactIntl = require("react-intl");

var _Item = _interopRequireDefault(require("../Item/Item"));

var _useA11y2 = _interopRequireDefault(require("../../hooks/useA11y"));

var _utils = require("../../lib/utils");

var _Comment = _interopRequireDefault(require("./Comment.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var options = {
  weekday: 'long',
  year: 'numeric',
  month: 'long',
  day: 'numeric'
};
/**
 * Comment component.
 *
 * TODO: Refactor `Item` to receive a ref from its parent. For now,
 *       wrapping it with a `li` outside the `Item` component
 *       to attach the ref so we can scroll to a comment when necessary.
 */

var Comment = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _classNames;

  var comment = _ref.comment,
      compactLayout = _ref.compactLayout,
      touchControls = _ref.touchControls,
      rest = _objectWithoutProperties(_ref, ["comment", "compactLayout", "touchControls"]);

  var _useA11y = (0, _useA11y2.default)(ref.current),
      onKeyDown = _useA11y.onKeyDown;

  var intl = (0, _reactIntl.useIntl)();
  var creator = comment.creator,
      bodyValue = comment.bodyValue,
      hasInsertAnnotation = comment.hasInsertAnnotation,
      hasReplaceAnnotation = comment.hasReplaceAnnotation,
      mentions = comment.mentions,
      modified = comment.modified,
      _comment$replies = comment.replies,
      replies = _comment$replies === void 0 ? [] : _comment$replies;
  var date = new Date(modified).toLocaleDateString(intl.locale, options);
  var userType = '';

  if (creator.id === rest.assetData.ownerId) {
    userType = intl.formatMessage({
      id: 'comments.item.owner'
    });
  }

  if (creator.affiliation === 'https://comments.acrobat.com/auth_providers/guest') {
    userType = intl.formatMessage({
      id: 'comments.item.guest'
    });
  }

  var commentText = (mentions === null || mentions === void 0 ? void 0 : mentions.length) > 0 ? (0, _utils.replaceIDWithName)(bodyValue, mentions) : bodyValue;

  if (hasInsertAnnotation || hasReplaceAnnotation) {
    var stringKey = hasInsertAnnotation ? 'comments.item.insert_label' : 'comments.item.replace_label';
    commentText = "".concat(intl.formatMessage({
      id: stringKey
    }), " ").concat(bodyValue);
  }

  var commentSummary = intl.formatMessage({
    id: 'comments.arialabel.comment'
  }, {
    author: creator.name,
    comment: commentText,
    date: date,
    replyCount: replies.length,
    userType: userType
  });
  return /*#__PURE__*/_react.default.createElement("li", {
    "aria-label": commentSummary,
    className: (0, _classnames.default)(_Comment.default.comment, (_classNames = {}, _defineProperty(_classNames, _Comment.default.compact, compactLayout), _defineProperty(_classNames, _Comment.default.touch, touchControls), _classNames)),
    onKeyDown: onKeyDown,
    ref: ref,
    role: "listitem",
    tabIndex: "0"
  }, /*#__PURE__*/_react.default.createElement(_Item.default, _extends({
    commentData: comment,
    compactLayout: compactLayout,
    touchControls: touchControls
  }, rest)));
});
Comment.propTypes = {
  comment: _propTypes.default.object,
  compactLayout: _propTypes.default.bool,
  touchControls: _propTypes.default.bool
};
Comment.displayName = 'Comment';
var _default = Comment;
exports.default = _default;